import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Icons } from "../Icons";
import { Link, useLocation } from "react-router-dom";
import { isQuestion, toSentenceCase } from "../../helpers/helpers";

const Breadcrumbs = (props) => {
  const location = useLocation();
  var arr = [{ text: "Home", link: "/" }];
  function breadcrumbArr() {
    if (location.pathname === "/") {
      return false;
    } else if (location.pathname === "/savings") {
      arr.push({ text: "Savings", link: location.pathname });
    } else if (location.pathname.includes("/manage")) {
      arr.push({ text: "Manage", link: "/manage" });
      if (location.pathname === "/manage/regular-contribution") {
        arr.push({
          text: "Regular contributions",
          link: location.pathname,
        });
      }
      if (location.pathname === "/manage/av-contribution") {
        arr.push({
          text: "AVC",
          link: location.pathname,
        });
      }
      if (location.pathname === "/manage/investments") {
        arr.push({ text: "Investments", link: location.pathname });
      }
      if (location.pathname === "/manage/boost-your-savings") {
        arr.push({ text: "Boost your savings", link: location.pathname });
      }
      if (location.pathname === "/manage/withdrawal") {
        arr.push({ text: "Withdrawal", link: location.pathname });
      }
    } else if (
      location.pathname.includes("/plan") ||
      (location.pathname.includes("/guidance") &&
        !location.pathname.includes("/learn/support/guidance-advice/"))
    ) {
      arr.push({ text: "Plan", link: "/plan" });
      if (location.pathname === "/plan/retirement-application") {
        arr.push({
          text: "Retirement application",
          link: location.pathname,
        });
      }
      if (location.pathname === "/plan/future-calculator") {
        arr.push({
          text: "Plan your future calculator",
          link: location.pathname,
        });
      }
    } else if (
      location.pathname.includes("/learn") &&
      !location.pathname.includes("/support") &&
      !location.pathname.includes("/about-tpt")
    ) {
      const trimmedString = location.pathname.split("/");
      const last = trimmedString[trimmedString.length - 2];
      arr.push({ text: "Learn", link: "/learn" });
      if (
        location.pathname === "/learn/view-all" ||
        location.pathname === "/learn/pension" ||
        location.pathname.includes("/learn/article") ||
        location.pathname.includes("/learn/webinar") ||
        location.pathname.includes("/learn/video")
      ) {
        arr.push({
          text: location.state?.breadCrumb
            ? location.state?.breadCrumb
            : isQuestion(
                location.pathname?.split("/")[2].charAt(0)?.toUpperCase() +
                  location.pathname?.split("/")[2].replace(/-/g, " ")?.slice(1), //eslint-disable-line
              ),
          link: location.pathname,
        });
      } else if (location.pathname === "/learn/" + last + "/") {
        arr.push({
          text: location.state?.breadCrumb
            ? location.state?.breadCrumb
            : isQuestion(
                location.pathname?.split("/")[2].charAt(0)?.toUpperCase() +
                  location.pathname?.split("/")[2].replace(/-/g, " ")?.slice(1), //eslint-disable-line
              ),
          link: "/learn/" + last,
        });
      }
    } else if (location.pathname === "/feedback/") {
      arr.push({ text: "Feedback", link: location.pathname });
    } else if (location.pathname === "/account-details") {
      arr.push({ text: "Account details", link: location.pathname });
    } else if (location.pathname === "/messages-and-documents") {
      arr.push({ text: "Messages & documents", link: location.pathname });
    } else if (location.pathname === "/communication-preferences") {
      arr.push({ text: "Communication settings", link: location.pathname });
    } else if (location.pathname === "/account-settings") {
      arr.push({ text: "Account settings", link: location.pathname });
    } else if (location.pathname.includes("/beneficiaries")) {
      arr.push({ text: "Beneficiaries", link: "/beneficiaries" });
      if (location.pathname === "/beneficiaries/add-beneficiaries") {
        arr.push({
          text: "Add beneficiaries",
          link: location.pathname,
        });
      }
    } else if (location.pathname === "/get-in-touch/") {
      arr.push({ text: "Get in touch", link: location.pathname });
    } else if (location.pathname === "/cookie-policy/") {
      arr.push({ text: "Cookie policy", link: location.pathname });
    } else if (location.pathname === "/privacy-policy/") {
      arr.push({ text: "Privacy policy", link: location.pathname });
    } else if (location.pathname === "/accessibility/") {
      arr.push({ text: "Accessibility", link: location.pathname });
    } else if (location.pathname === "/terms-conditions/") {
      arr.push({ text: "Terms & conditions", link: "location.pathname" });
    } else if (location.pathname.includes("/support/")) {
      const trimmedString = location.pathname.split("/");
      const last = trimmedString[trimmedString.length - 2];
      arr.push({ text: "Learn", link: "/learn" });
      arr.push({ text: "Support", link: "/learn/support/help-guides/" });
      if (last) {
        let formattedLast =
          last.charAt(0).toUpperCase() + last.slice(1).replace(/-/g, " ");
        let formattedStr = formattedLast
          .split(" ")
          .map((word, index, arr) => {
            if (word.toLowerCase() === "faq") {
              return "FAQs";
            } else if (
              word.toLowerCase() === "jargon" &&
              arr[index + 1]?.toLowerCase() === "buster"
            ) {
              return "Jargon";
            } else if (
              word.toLowerCase() === "buster" &&
              arr[index - 1]?.toLowerCase() === "jargon"
            ) {
              return "buster";
            } else if (
              word.toLowerCase() === "help" &&
              arr[index + 1]?.toLowerCase() === "guides"
            ) {
              return "Help";
            } else if (
              word.toLowerCase() === "guides" &&
              arr[index - 1]?.toLowerCase() === "help"
            ) {
              return "guides";
            } else if (word.toLowerCase() === "webinar") {
              return "Webinars";
            } else {
              return word;
            }
          })
          .join(" ");

        if (
          !formattedStr.includes("Jargon buster") &&
          !formattedStr.includes("Help guides") &&
          !formattedStr.includes("Additional support") &&
          !formattedStr.includes("Financial coercion") &&
          !formattedStr.includes("Enhanced support")
        ) {
          formattedStr = formattedStr.replace(/ /g, " & ");
        }
        arr.push({
          text: formattedStr,
          link: location.pathname,
        });
      }
    } else if (location.pathname === "/help-guides/webinar") {
      const trimmedString = location.pathname.split("/");
      const last = trimmedString[trimmedString.length - 1];
      arr.push({ text: "Learn", link: "/learn" });
      arr.push({ text: "Support", link: "/learn/support/help-guides/" });
      const { breadCrumb } = location.state;
      const formatted = breadCrumb.replace(/-/g, " ");
      if (last) {
        const formattedLast =
          formatted.charAt(0).toUpperCase() + formatted.slice(1);
        arr.push({
          text: "Help guides",
          link: "/learn/support/help-guides/",
        });
        arr.push({
          text: formattedLast,
          link: location.pathname,
        });
      }
    } else if (location.pathname.includes("/help-guides/video")) {
      const trimmedString = location.pathname.split("/");
      const last = trimmedString[trimmedString.length - 2];
      arr.push({ text: "Learn", link: "/learn" });
      arr.push({ text: "Support", link: "/learn/support/help-guides/" });
      const { breadCrumb } = location.state ? location.state : "Help guides";
      const breadcrumbFormatted =
        breadCrumb?.charAt(0)?.toUpperCase() +
        breadCrumb?.slice(1)?.replace(/-/g, " ");
      if (last) {
        const formattedLast =
          last.charAt(0).toUpperCase() + last.slice(1).replace(/-/g, " ");
        arr.push({
          text: formattedLast,
          link: "/learn/support/help-guides/",
        });
        arr.push({
          text: breadcrumbFormatted,
          link: location.pathname,
        });
      }
    } else if (location.pathname.includes("/about-tpt/")) {
      const trimmedString = location.pathname.split("/");
      const last = trimmedString[trimmedString.length - 2];
      arr.push({ text: "Learn", link: "/learn" });
      arr.push({
        text: "About TPT",
        link: "/learn/about-tpt/about-tpt/",
      });
      if (last) {
        const formattedLast =
          last.charAt(0).toUpperCase() + last.slice(1).replace(/-/g, " ");
        let formattedStr = formattedLast
          .split(" ")
          .map((word) => {
            if (word.toLowerCase() === "tpt") {
              return "TPT";
            } else if (word.toLowerCase() === "tpts") {
              return "TPT's";
            } else {
              return word;
            }
          })
          .join(" ");
        arr.push({
          text: formattedStr,
          link: location.pathname,
        });
      }
    } else if (location.pathname.includes("/useful-links/")) {
      arr.push(
        { text: "Learn", link: "/learn" },
        { text: "Useful Links", link: "/useful-links/" }, //eslint-disable-line
      );
    } else if (location.pathname.includes("/help-guides")) {
      const trimmedString = location.pathname.split("/");
      const last = trimmedString[trimmedString.length - 2];
      const breadcrumbFormatted =
        last?.charAt(0).toUpperCase() + last.slice(1).replace(/-/g, " ");
      if (location.pathname === "/help-guides/" + last + "/") {
        arr.push({
          text: "Learn",
          link: "/learn",
        });
        arr.push({
          text: "Support",
          link: "/learn/support/help-guides/",
        });
        arr.push({ text: "Help guides", link: "/learn/support/help-guides/" });
        arr.push({
          text: breadcrumbFormatted,
          link: "/help-guides/" + last,
        });
      }
    } else if (location.pathname.includes("/product-overview")) {
      let productPageText = location.search.replace(/\?/g, "");
      if (productPageText?.includes("/")) {
        const arr = productPageText.split("/");
        productPageText = arr[arr.length - 1];
      }
      const sentenceCaseStr = toSentenceCase(productPageText);
      arr.push(
        { text: "Plan", link: "/plan?tab=retirementExplorer" },
        { text: sentenceCaseStr, link: "" }, //eslint-disable-line
      );
    } else {
      arr.push({ text: "Page not found", link: "" });
    }
    return arr;
  }

  const sectionBreadcrumbArr = (
    allPots,
    handleViewBack,
    selectedPotNameId,
    handleViewAllPot, //eslint-disable-line
  ) => {
    var arr = [{ text: "Overview", link: "", onclick: handleViewBack }];
    if (allPots === "All pots") {
      arr.push({ text: "All pots", link: "", onclick: handleViewAllPot });
    }
    if (allPots === "Drawdown details") {
      arr.push({
        text: "Drawdown details",
        link: "",
        onclick: handleViewAllPot,
      });
    }
    if (
      selectedPotNameId &&
      selectedPotNameId.trim() !== "undefined" &&
      selectedPotNameId.trim() !== "undefined undefined"
    ) {
      arr.push({ text: selectedPotNameId, link: "" });
    }
    return arr;
  };
  const commanArr = props?.isPageSection
    ? sectionBreadcrumbArr(
        props.allPots,
        props.handleViewBack,
        props.selectedPotNameId,
        props.handleViewAllPot, //eslint-disable-line
      )
    : breadcrumbArr();
  return (
    <div>
      {location.pathname !== "/" ? (
        <Breadcrumb aria-label={props.ariaLabel}>
          {props?.isPageSection ? (
            ""
          ) : (
            <li style={{ marginRight: "10px", marginTop: "2px" }}>
              <Icons iconname="breadcrumb-home" variant="icon-thirteen-px" />
            </li>
          )}
          {commanArr.map((item, index, breadcrumbArr) => {
            const last = index + 1 === breadcrumbArr.length;
            return (
              <Breadcrumb.Item
                key={index}
                linkAs={Link}
                linkProps={{ to: item.link }}
                onClick={item.onclick}
                className={
                  last
                    ? "bold-text no-underline breadcrumb-active"
                    : "breadcrumb-link breadcrumb-not-active"
                }
              >
                {item.text}
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      ) : (
        ""
      )}
    </div>
  );
};

export default Breadcrumbs;
